// extracted by mini-css-extract-plugin
export default {"logoFrame":"Clients_logoFrame__ye37e"};